import { createContext, useContext, useRef, useCallback, useMemo } from "react";

interface AIPageContextValue {
  setFilteredProjectIds: (ids: string[]) => void;
  getFilteredProjectIds: () => string[];
}

const AIPageContext = createContext<AIPageContextValue>({
  setFilteredProjectIds: () => {},
  getFilteredProjectIds: () => [],
});

export function AIPageContextProvider({ children }: { children: React.ReactNode }) {
  const ref = useRef<string[]>([]);
  const setFilteredProjectIds = useCallback((ids: string[]) => { ref.current = ids; }, []);
  const getFilteredProjectIds = useCallback(() => ref.current, []);
  const value = useMemo(() => ({ setFilteredProjectIds, getFilteredProjectIds }), [setFilteredProjectIds, getFilteredProjectIds]);
  return <AIPageContext.Provider value={value}>{children}</AIPageContext.Provider>;
}

export function useAIPageContext() {
  return useContext(AIPageContext);
}
